import React from 'react';

import S from './Phone.module.css';

export const PhoneImg = () => (
  <div className={S.root}>
    <div className={S.bgAngled}></div>
    <div className={S.truba}>
      <b></b>
    </div>
  </div>
);
